import React, { memo } from 'react'
import { Dimmer, Loader } from 'semantic-ui-react'

function PageLoader({ active, content, children }) {
    return (
        <Dimmer.Dimmable className='page-loader d-flex flex-grow-1 flex-column' blurring dimmed={active}>
            <Dimmer active={active} inverted className='d-print-none'><Loader content={content ? content : 'Aguarde um instante...'} /></Dimmer>
            {children}
        </Dimmer.Dimmable>
    )
}

export default memo(PageLoader)
